import { Http } from 'Core/utils'

import { Dashboard } from 'Portals/Supplier/entities'

import { baseLastThreeUrl, baseUrl } from './constants'

export const retrieveLanguages = (): Promise<Entity[]> => Http.get('/languages')

export const retrieveLandfillStatistics = (): Promise<Dashboard.LandfillStatistics> =>
	Http.get(`${baseUrl}/summary`)

export const retrieveTotalSpent = (): Promise<number> => Http.get(`${baseUrl}/total-spent`)

export const retrieveLastThreeInvoices = (): Promise<Dashboard.LastThreeBasic[]> =>
	Http.get(`${baseLastThreeUrl}`)

export const retrieveTreatmentMethodsMostUsed = (): Promise<Dashboard.TreatmentMethod.MostUsed[]> =>
	Http.get(`${baseUrl}/charts/treatment-methods`)

export const retrieveLandfills = (): Promise<Dashboard.Landfill[]> =>
	Http.get(`${baseUrl}/charts/landfill`)

export const retrieveLastReports = (): Promise<{
	reports: Dashboard.Report.Basic[]
	total: number
}> => Http.get(`${baseUrl}/recent-reports`)

export const retrieveMostUsedItems = (): Promise<{
	items: Dashboard.Item.MostUsedItem[]
	total: number
}> => Http.get(`${baseUrl}/most-used-items`)

export const retrieveNotifications = (): Promise<Dashboard.Notification[]> =>
	Http.get(`/notifications`)

export const markAsRead = (notificationIds: Dashboard.NotificationIds): Promise<void> =>
	Http.post(`/notifications/markAsRead`, notificationIds)
